<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('shortDomains.shortDomain') }}
                <template v-if="isLoaded"> {{ $t('addNew') }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        :to="{ name: 'short-domains.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('shortDomains.shortDomainsList') }}</span>
                        <span class="hidden-xs">{{ $t('shortDomains.shortDomainsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <ShortDomainsForm
                            v-show="isLoaded"
                            @loaded="onLoaded"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ShortDomainsForm from '@/components/short-domains/ShortDomainsForm';

export default {
    components: {
        ShortDomainsForm,
    },

    data() {
        return {
            isLoaded: false,
            shortDomain: {},
        };
    },

    computed: {
        headTitle() {
            return `${this.$t('shortDomains.shortDomain')} ${this.$t('addNew')}`;
        },
    },

    methods: {
        onLoaded(shortDomain) {
            this.shortDomain = shortDomain;
            this.isLoaded = true;
        },
    },
};
</script>
